import { LargeCategory, MiddleCategory, SearchCategoryState, SmallCategory } from '../../../redux/reducers/SearchCategoryReducer';
import { uniqBy } from 'lodash';
import { SearchConditionItem, SearchConditionState } from '../../../redux/reducers/SearchConditionReducer';
/**
 * 初回登録者または担当者の場合はsmallCategoryCdをsmallCategoryCdNameに書き換え
 */
export function convertSearchCategory(searchCategory: SearchCategoryState) {
  searchCategory.categories.forEach((largeCategory) =>
    largeCategory.middleCategory.forEach((middleCategory) => {
      if (
        middleCategory.smallCategory &&
        (middleCategory.middleCategoryCdMapping === 'closingSalesmanName' ||
          middleCategory.middleCategoryCdMapping === 'mainClosingSalesmanName')
      ) {
        middleCategory.smallCategory = uniqBy(middleCategory.smallCategory, 'smallCategoryCdName').map((itemConvert) => ({
          smallCategoryCd: itemConvert.smallCategoryCdName,
          smallCategoryCdName: itemConvert.smallCategoryCdName,
        }));
      }
    })
  );

  return searchCategory;
}

export const isActionNoInputBySpecialCondition = (largeCategoryCd: string, middleCategoryCd: string, smallCategoryCd: string) => {
  return largeCategoryCd === '02' && middleCategoryCd === '11' && smallCategoryCd === '00';
};

export const getSmallCategoriesWithoutActionNoInput = (middleCategory: MiddleCategory, largeCategory: LargeCategory) => {
  if (!Array.isArray(middleCategory.smallCategory) || !middleCategory.smallCategory.length) return [];
  return middleCategory.smallCategory.filter((smallCategory: SmallCategory) => {
    return !isActionNoInputBySpecialCondition(
      largeCategory.largeCategoryCd,
      middleCategory.middleCategoryCd,
      smallCategory.smallCategoryCd
    );
  });
};

export const getSearchConditionListWithoutNoInput = (filterData: SearchConditionState) => {
  return filterData.map((searchConditionItem: SearchConditionItem) => {
    if (searchConditionItem.searchConditionName === 'actionType') {
      return {
        ...searchConditionItem,
        specifiedCondition: searchConditionItem.specifiedCondition.filter((condition) => condition !== '00'),
      };
    }
    return searchConditionItem;
  });
};
